import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import CarriersContainer from '../../containers/logistics/Carriers';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { isFiltered, sortTable, formatPrimaryContact } from '../../libs/utility';
import CheckIcon from '@material-ui/icons/Check';

import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import FMPHeadline from '../../components/ui/FMPHeadline';
const styles = (theme) => ({
	...getSharedStyles(theme),
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
});

let columnData = [
	{ id: 'name', numeric: false, label: 'Name' },
	{ id: 'primaryContact', numeric: false, label: 'Primary Contact' },
	{ id: 'deliveryEmails', numeric: false, label: 'Delivery Emails' },
	{ id: 'isQuickbooksLinked', numeric: false, label: 'QB Link', padding: 'checkbox' },
	{ id: 'hasScheduleEmails', labels: ['Schedule', 'Emails'] },
	{ id: 'edit', numeric: false, label: 'Edit' },
];

class Carriers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isViewDialogOpen: false,
			viewStation: {},
			isDcDialogOpen: false,
			dcStation: {},
			order: 'asc',
			orderBy: 'name',
			search: '',
		};
	}

	componentDidMount() {
		if (!this.props.carriers.length) {
			this.props.searchCarriers();
		}
	}

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleEdit = (carrierId) => {
		this.props.history.push(`/logistics/carrier/update/${carrierId}`);
	};

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	render() {
		const { classes, carriers, authUser, isExternalLogistics } = this.props;
		const { order, orderBy, search } = this.state;
		if (!carriers || !authUser) {
			return null;
		}
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		let data = carriers.reduce((result, carrier) => {
			if (isFiltered({ search, data: carrier, fields: ['name'] })) {
				return result;
			}

			const { deliveryEmails, contacts, billingQuickbooksVendorId, scheduleEmails } = carrier;
			const isQuickbooksLinked = billingQuickbooksVendorId ? <CheckIcon /> : <div />;

			let emails = _.first(deliveryEmails);
			if (deliveryEmails.length > 1) {
				emails += `, ${deliveryEmails.length - 1} more`;
			}

			const primaryContact = formatPrimaryContact(_.first(contacts));

			const hasScheduleEmails = _.isEmpty(scheduleEmails) ? '-' : <CheckIcon />;

			result.push({
				carrierId: carrier.carrierId,
				name: carrier.name,
				primaryContact,
				emails,
				isQuickbooksLinked,
				hasScheduleEmails,
			});
			return result;
		}, []);

		data = sortTable({ data, order, orderBy });

		if (isExternalLogistics) {
			columnData = [
				{ id: 'name', numeric: false, label: 'Name' },
				{ id: 'primaryContact', numeric: false, label: 'Primary Contact' },
				{ id: 'deliveryEmails', numeric: false, label: 'Delivery Emails' },
				// { id: 'isQuickbooksLinked', numeric: false, label: 'QB Link', padding : 'checkbox' },
				{ id: 'edit', numeric: false, label: 'View' },
			];
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Carriers"
						value={this.state.search}
						onChange={this.handleSearch}
						buttonText="Add Carrier"
						url="/logistics/carrier/add"
						canMakeUpdates={isExternalLogistics ? false : canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{data.map((row) => {
									return (
										<TableRow hover className={classes.row} key={row.carrierId}>
											<TableCell>{row.name}</TableCell>
											<TableCell>{row.primaryContact}</TableCell>
											<TableCell>{row.emails}</TableCell>
											{!isExternalLogistics && <TableCell>{row.isQuickbooksLinked}</TableCell>}
											{!isExternalLogistics && <TableCell>{row.hasScheduleEmails}</TableCell>}
											{canMakeUpdates && (
												<TableCell style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEdit(row.carrierId)}
													>
														{isExternalLogistics && 'View'}
														{!isExternalLogistics && 'Edit'}
													</Button>
												</TableCell>
											)}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

Carriers.propTypes = {
	classes: PropTypes.object.isRequired,
	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), CarriersContainer, AuthUserContainer])(Carriers);
